import React, { memo, useState, useContext, useEffect } from 'react';
import moment from 'moment';
import { useMemoizedFn } from 'ahooks';
import { context as Context } from '@gp/components/Context';
// import Loading from '@gp/components/Loading';
import PlaceholderCard from '@gp/components/PlaceholderCard';
import Filter, { IFilter } from './components/Filter';
import ManagementTeam from './components/ManagementTeam';
import Headcounts from './components/Headcounts';
import HeadcountCost from './components/HeadcountCost';
import FiveYearHeadcounts from './components/FiveYearHeadcounts';
import usePageLog from '@gp/hooks/usePageLog';
import usePageInit from './hook/usePageInit';
import { checkDateRangeDiff } from './utils/common';
import { MAX_DIFF_MONTHS } from './utils/constants';
import './index.scss';

interface PeopleDetailsPropsType {}

const DEFAULT_PROPS: PeopleDetailsPropsType = {};

function PeopleDetails(props: PeopleDetailsPropsType) {
  const {} = props;

  const { studioId, studioName }: StudioOverallDetailContextTypes =
    useContext(Context) || {};

  const [filter, setFilter] = useState<IFilter>({
    date_type: 'Month',
    start_date: '',
    end_date: '',
  });

  const handleFilterChange = useMemoizedFn((payload: IFilter) => {
    const newFilter = { ...filter, ...payload };
    setFilter(newFilter);
  });

  const { isLoading, dateRangeData } = usePageInit({ studioId });
  useEffect(() => {
    const { start_date, end_date } = dateRangeData || {};
    if (!start_date || !end_date) return;
    /* let startDateTemp = moment(start_date);
    const endDateTemp = moment(end_date);
    const isRangeValid = checkDateRangeDiff(startDateTemp, endDateTemp);
    if (!isRangeValid) {
      startDateTemp = moment(endDateTemp).subtract(
        MAX_DIFF_MONTHS - 1,
        'months',
      );
    } */
    const initEndDate = end_date || '';
    const initStartDate = Number(initEndDate?.substring(0, 4)) > Number(start_date?.substring(0, 4))
      ? `${initEndDate?.substring(0, 4)}-01-01` : start_date || '';
    const newFilter = {
      ...filter,
      start_date: initStartDate,
      end_date: initEndDate,
    };
    setFilter(newFilter);
  }, [dateRangeData]);

  usePageLog({
    pageId: 'STUDIO_OVERALL_DETAILS_PEOPLE',
    uidType: 'studio_id',
    uid: studioId,
    extInfo: studioName,
  });

  /* if (isLoading)
    return (
      <Loading
        style={{ position: 'unset' }}
        innerStyle={{ height: 'calc(100% - 20px)', top: 20 }}
        loading
        loadingBg="#f2f3f5"
      />
    ); */

  return (
    <div className="dbg-studio-overall-details-people">
      <ManagementTeam />
      <Filter
        style={{ margin: '20px 0 10px' }}
        dateRangeData={dateRangeData}
        filter={filter}
        isLimitMaxSelectRange
        onFilterChange={handleFilterChange}
      />
      <Headcounts filter={filter} />
      <HeadcountCost filter={filter} />
      <FiveYearHeadcounts />
      <PlaceholderCard title="Talent Plan Materials" />
    </div>
  );
}

PeopleDetails.defaultProps = DEFAULT_PROPS;

export default memo(PeopleDetails);
